import React, { useState, useEffect } from 'react'

interface InactivityWarningToastProps {
  initialSeconds: number
  onStayLoggedIn: () => void
}

export function InactivityWarningToast({ initialSeconds, onStayLoggedIn }: InactivityWarningToastProps) {
  const [secondsRemaining, setSecondsRemaining] = useState(initialSeconds)

  useEffect(() => {
    if (secondsRemaining <= 0) {
      return
    }

    const interval = setInterval(() => {
      setSecondsRemaining((prev) => {
        if (prev <= 1) {
          clearInterval(interval)
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [secondsRemaining])

  // Update the seconds if the initial value changes (in case of reset)
  useEffect(() => {
    setSecondsRemaining(initialSeconds)
  }, [initialSeconds])

  return (
    <div className="flex flex-col gap-2">
      <div className="font-medium">Session expires in {secondsRemaining} seconds</div>
      <div className="text-sm text-muted-foreground">
        Your session will expire due to inactivity. Move your mouse or press a key to stay logged in.
      </div>
      <button
        onClick={onStayLoggedIn}
        className="self-start px-3 py-1 text-sm bg-primary text-primary-foreground rounded hover:bg-primary/90"
      >
        Stay Logged In
      </button>
    </div>
  )
}
